import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Feedback.css";

/* ─── Icons ─── */
const ConvertIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const StarIcon = ({ filled }) => (
  <svg width="24" height="24" viewBox="0 0 24 24"
    fill={filled ? "#F59E0B" : "none"}
    stroke={filled ? "#F59E0B" : "#CBD5E1"}
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);
const ChevronDown = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

/* ─── Data ─── */
const CATEGORIES = ["General Feedback", "Bug Report", "Feature Request", "Improvement Suggestion"];

/* ─── Navbar ─── */
function Navbar() {
  return (
    <nav className="fb-navbar">
      <div className="fb-navbar-inner">
        <div className="fb-logo">
          <ConvertIcon />
          <span className="fb-logo-text">ConvertPro</span>
        </div>
        <div className="fb-nav-links">
          <a href="/" className="fb-nav-link">Home</a>
          <a href="/feedback" className="fb-nav-link fb-nav-link--active">Feedback</a>
          <a href="/pricing" className="fb-nav-link">Pricing</a>
          <a href="/contact" className="fb-nav-link">Contact</a>
        </div>
        <a href="/signup" className="fb-nav-cta">Get Started Free</a>
      </div>
    </nav>
  );
}

/* ─── Main ─── */
export default function ConvertProFeedback() {
    const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", category: "", message: "" });
  const [rating, setRating] = useState(3);
  const [hoveredStar, setHoveredStar] = useState(0);

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const API_URL =
    process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const response = await fetch(
        `${API_URL}/feedback`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: form.email,
            type: form.category,
            feedback_text: form.message
          }),
        }
      );

      const result = await response.json();

      alert(result.message);

      navigate("/");

    } catch (error) {

      console.error(error);

      alert("Failed to submit feedback");
    }
  };

  return (
    <div className="fb-page">
      <Navbar />

      <main className="fb-main">
        {/* Hero */}
        <div className="fb-hero">
          <h1 className="fb-title">We Value Your Feedback</h1>
          <p className="fb-subtitle">Help us improve ConvertPro by sharing your experience and suggestions.</p>
        </div>

        {/* Content */}
        <div className="fb-content-grid">
          {/* Left — Form */}
          <div className="fb-card fb-form-card">
            <h3 className="fb-card-title">Send Us Your Feedback</h3>
            <form className="fb-form" onSubmit={handleSubmit}>
              <div className="fb-field-row">
                <div className="fb-field">
                  <label className="fb-label">Name</label>
                  <input className="fb-input" type="text" placeholder="Your name" value={form.name} onChange={update("name")} />
                </div>
                <div className="fb-field">
                  <label className="fb-label">Email</label>
                  <input className="fb-input" type="email" placeholder="you@example.com" value={form.email} onChange={update("email")} />
                </div>
              </div>

              <div className="fb-field">
                <label className="fb-label">Feedback Category</label>
                <div className="fb-select-wrap">
                  <select className="fb-select" value={form.category} onChange={update("category")}>
                    <option value="">Select a category</option>
                    {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <span className="fb-select-arrow"><ChevronDown /></span>
                </div>
              </div>

              <div className="fb-field">
                <label className="fb-label">Rating</label>
                <div className="fb-stars">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      type="button"
                      className="fb-star-btn"
                      onClick={() => setRating(star)}
                      onMouseEnter={() => setHoveredStar(star)}
                      onMouseLeave={() => setHoveredStar(0)}
                    >
                      <StarIcon filled={star <= (hoveredStar || rating)} />
                    </button>
                  ))}
                  <span className="fb-rating-text">{rating}/5</span>
                </div>
              </div>

              <div className="fb-field">
                <label className="fb-label">Message</label>
                <textarea
                  className="fb-textarea"
                  rows={5}
                  placeholder="Tell us what you think..."
                  value={form.message}
                  onChange={update("message")}
                />
              </div>

              <button
                type="submit"
                className="fb-btn-primary"
              >
                Submit Feedback
              </button>
            </form>
          </div>
        </div>
      </main>

      <footer className="fb-footer">
        <p>© 2026 ConvertPro. All rights reserved.</p>
      </footer>
    </div>
  );
}
